export const INTEGRATION_MAILCHIMP_CONNECTED = 'INTEGRATION_MAILCHIMP_CONNECTED'
export const INTEGRATION_STRIPE_CONNECTED = 'INTEGRATION_STRIPE_CONNECTED'
export const INTEGRATION_CALENDAR_CONNECTED = 'INTEGRATION_CALENDAR_CONNECTED'
export const INTEGRATION_MINDBODY_CONNECTED = 'INTEGRATION_MINDBODY_CONNECTED'
export const INTEGRATION_WORKFLOWMAX_CONNECTED = 'INTEGRATION_WORKFLOWMAX_CONNECTED'
